import { Heart } from "lucide-react";
import useFavourites from "@/hooks/useFavourites";

// Heart toggle used on hall panels, grid tiles and the detail page.
export default function HeartButton({ slug, title, className = "", testId, withLabel = false }) {
  const { has, toggle } = useFavourites();
  const active = has(slug);
  return (
    <button
      type="button"
      className={`heart-btn ${active ? "is-active" : ""} ${className}`}
      onClick={(e) => { e.stopPropagation(); toggle(slug); }}
      aria-pressed={active}
      aria-label={active ? `Remove ${title} from your shortlist` : `Add ${title} to your shortlist`}
      data-cursor={active ? "Remove" : "Save"}
      data-testid={testId || `heart-${slug}`}
    >
      <Heart className="heart-btn__ico" strokeWidth={1.5} />
      {withLabel && <span className="mono-caps heart-btn__label">{active ? "Saved" : "Save"}</span>}
    </button>
  );
}
